import { CSSObject, Divider, Drawer, styled, Theme } from '@mui/material';
import { orange } from '@mui/material/colors';
import {
	getNavDrawerCollapsedWidth,
	NAV_DRAWER_WIDTH,
} from 'shared/_components/app-layout/constants';
import { IconLogo } from 'shared/_ui/icon';
import configs from 'shared/constants/configs';

/** New design sidebar colors (`--nd-dark`, `--nd-dark-2`, `--nd-text-faint`, `--nd-amber`). */
export const NAV_COLORS = {
	bg: '#0f172a',
	bgHover: '#1e293b',
	text: '#94a3b8',
	textActive: '#ffffff',
	accent: '#fbbf24',
} as const;

export const NavDrawerLogoIcon = styled(IconLogo, {
	shouldForwardProp: (propName: PropertyKey) => propName !== 'expanded',
})<{ expanded: boolean }>(({ theme, expanded }) => ({
	color: configs.suffix ? orange[500] : NAV_COLORS.accent,
	height: 60,
	width: 60,
	transition: `height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
							  width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms`,
	[theme.breakpoints.up('sm')]: {
		height: expanded ? 60 : 30,
		width: expanded ? 60 : 30,
	},
}));

export const NavDrawerHeader = styled('div')<{ expanded: boolean }>(({ theme }) => ({
	width: '100%',
	flexShrink: 0,
	padding: theme.spacing(2),
	paddingTop: theme.spacing(6),
	marginBottom: theme.spacing(4),
	textAlign: 'center',
	position: 'sticky',
	zIndex: 1,
	background: NAV_COLORS.bg,
	top: 0,
}));

export const openedMixin = (theme: Theme): CSSObject => ({
	width: NAV_DRAWER_WIDTH,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	// overflowX: 'hidden',
});

export const closedMixin = (theme: Theme): CSSObject => ({
	width: NAV_DRAWER_WIDTH,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	// overflowX: 'hidden',
	[theme.breakpoints.up('sm')]: {
		width: getNavDrawerCollapsedWidth(theme),
	},
});

export const NavDrawer = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'expanded' })<{
	expanded: boolean;
}>(({ theme, expanded, open }) => ({
	flexShrink: 0,
	'&.MuiDrawer-root .MuiDrawer-paper': {
		backgroundColor: 'transparent',
		// '&::-webkit-scrollbar-thumb': {
		// 	background: alpha(theme.palette.common.white, 0.25),
		// },
		// '&::-webkit-scrollbar-track': {
		// 	background: grey[900],
		// },
		paddingInlineStart: 0,
		// TODO: replace transform: 'scaleX(-1)' with `scale: -1 0` in 104 chrome
		// transform: 'scaleX(-1)', // Move scroll to the left
		alignItems: 'flex-end',
		[theme.breakpoints.down('sm')]: {
			boxShadow: 'none',
		},
	},
	...(expanded && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!expanded && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}));

export const NavDrawerInner = styled('div', { shouldForwardProp: (prop) => prop !== 'expanded' })<{
	expanded: boolean;
}>(({ theme, expanded }) => ({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	// transform: 'scaleX(-1)', // Move scroll to the left
	// width: `calc(100% - ${
	// 	expanded ? NAV_BAR_DRAWER_RIGHT_SPACE : NAV_BAR_DRAWER_RIGHT_SPACE_COLLAPSED
	// }px)`,
	backgroundColor: NAV_COLORS.bg,
}));

export const NavDrawerDivider = styled(Divider)({
	borderColor: NAV_COLORS.bgHover,
});

export const Div = styled('div')();
